import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environment/environment';

/**
 * Guard that blocks the Project Management Insights route when the feature is
 * disabled for the current environment. Controlled by `environment.enablePmInsightsTab`
 * (independent of `isProduction`).
 */
export const pmInsightsGuard: CanActivateFn = () => {
  if (environment.enablePmInsightsTab !== true) {
    return inject(Router).createUrlTree(['/dashboard', 'project-management', 'summary']);
  }
  return true;
};
